var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"success"},[_c('img',{staticClass:"icon",attrs:{"src":require("@/assets/images/enroll/success.png"),"alt":""}}),_c('p',{staticClass:"tip"},[_vm._v("支付成功~")]),_c('div',{staticClass:"footer dcc"},[_c('button',{staticClass:"btn1",on:{"click":function($event){return _vm.onBack()}}},[_vm._v("返回")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }